<h2>Asociar Medios de Verificación</h2>
<mat-dialog-content> 
    <p>
        A continuación  se muestran todos los medios de verificación cargados en la plataforma.
    </p>

    <ol>
        <li>Marcar en la casilla <b>"Asociar"</b> el o los medio(s) de verificación que acreditan la práctica de gestión evaluada en este elemento de gestión.</li>
        <li>Ingresar en la columna <b>"Comentario"</b>, un texto que explique la asociación de el o los medio(s) de verificación al elemento de gestión en cuestión.
            <br>Ejemplo: Ver página 8 a la 12 del documento.</li>
        <li>Presionar el botón <b>"Guardar"</b> y confirmar la asociación.</li>
    </ol>


    <br>

    <div class="cargando"><mat-spinner *ngIf="cargando"></mat-spinner></div>
    <table class="medio-verificacion" *ngIf="!cargando">
        <tr> 
            <th></th>
            <th> MEDIO DE VERIFICACIÓN</th>
            <th> COMENTARIO </th>   
            <th> ASOCIAR </th>   
        </tr>
        <tr *ngFor="let medio of mediosVerificacion; let m = index " > 
            <td>{{m + 1}}</td> 
            <td>{{medio.nombreArchivo}}</td> 
            <td><input matInput type="text" [(ngModel)]="medio.comentario" [disabled]="!medio.selected"></td> 
            <td><mat-checkbox class="example-margin" [disabled]="medio.disabled" [(ngModel)]="medio.selected" name="check-medios" [id]="medio.idMedioVerificacion" (change)="getCheckbox(m)"></mat-checkbox></td> 
        </tr>
        <tr *ngIf="mediosVerificacion.length == 0" > 
            <td colspan="4" style="text-align: center;">No existen Medios de verificación para asociar.</td> 
        </tr>
        
    </table>
</mat-dialog-content> 

<mat-dialog-actions align="end">
    <div class="button-row"> 
        <button mat-raised-button class="btn-cancelar" (click)="onNoClick()" mat-dialog-close >Cancelar</button>
        <button mat-raised-button class="btn-confirmar" (click)="guardarAsociacion()">
            GUARDAR
        </button>
    </div>
</mat-dialog-actions>
